import React from "react";
import { FaLaptopCode, FaBriefcase } from "react-icons/fa";

const Experience = () => {
  return (
    <section
      id="experience"
      style={{
        padding: "80px 50px",
        background: "#000",
        color: "#fff",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "50px",
          fontSize: "2rem",
          color: "#f5f9f8ff",
        }}
      >
        Experience
      </h2>

      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          position: "relative",
        }}
      >
        {/* Timeline items */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "50px",
          }}
        >
          {/* IT Analyst Intern */}
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <FaLaptopCode size={40} color="#00b894" />
            <div
              style={{
                background: "#1e1e1e",
                padding: "20px",
                borderRadius: "10px",
                flex: 1,
              }}
            >
              <strong>IT Analyst Intern</strong> – Guide Me Through, India
              <br />
              <em>Feb 2023 – Dec 2023</em>
            </div>
          </div>

          {/* Software Developer Intern */}
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <FaBriefcase size={40} color="#00b894" />
            <div
              style={{
                background: "#1e1e1e",
                padding: "20px",
                borderRadius: "10px",
                flex: 1,
              }}
            >
              <strong>Software Developer Intern</strong> – Goa Shipyard Limited,
              India
              <br />
              <em>Aug 2022 – Oct 2022</em>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
